/*
  MIMOYA — images des sections chargées à l'approche.
  Fichier ajouté hors référentiel FullStack : survit aux mises à jour.

  Les sections MIMOYA sous le bloc produit rendent leurs images sans source (snippet mimoya-lazy-img :
  data-mimoya-src / data-mimoya-srcset, attribut data-mimoya-lazy). Quand une section arrive à moins
  d'un écran de la zone visible, toutes ses images reçoivent leurs vraies sources d'un coup (les
  cartes d'un carrousel encore hors écran sont donc prêtes avant d'être balayées). Rien n'est
  téléchargé tant que le visiteur ne s'en approche pas, même sur une connexion lente (le chargement
  différé natif du navigateur, lui, prend jusqu'à 2 500 px d'avance).
  Chargé en module : une seule exécution même si plusieurs sections l'appellent.
*/
(function () {
  if (window.mimoyaLazyMedia) {
    window.mimoyaLazyMedia.scan(document);
    return;
  }

  var observer = null;

  function load(root) {
    if (!root || root.nodeType !== 1) return;
    var images = root.matches('img[data-mimoya-lazy]') ? [root] : root.querySelectorAll('img[data-mimoya-lazy]');
    Array.prototype.forEach.call(images, function (image) {
      var srcset = image.getAttribute('data-mimoya-srcset');
      var src = image.getAttribute('data-mimoya-src');
      image.loading = 'eager';
      if (srcset) image.setAttribute('srcset', srcset);
      if (src) image.setAttribute('src', src);
      image.removeAttribute('data-mimoya-srcset');
      image.removeAttribute('data-mimoya-src');
      image.removeAttribute('data-mimoya-lazy');
    });
  }

  function groupOf(image) {
    return image.closest('.shopify-section') || image.parentElement;
  }

  function scan(root) {
    var images = (root || document).querySelectorAll('img[data-mimoya-lazy]');
    if (!observer) {
      Array.prototype.forEach.call(images, load);
      return;
    }
    Array.prototype.forEach.call(images, function (image) {
      var group = groupOf(image);
      if (group && !group.mimoyaLazyWatched) {
        group.mimoyaLazyWatched = true;
        observer.observe(group);
      }
    });
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.mimoyaLazyWatched = false;
          load(entry.target);
        });
      },
      { rootMargin: '100% 0px' }
    );
  }

  window.mimoyaLazyMedia = { scan: scan, load: load };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Éditeur de thème : une section rechargée doit être réobservée.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
